// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__1Yw6Z","path":"style_path__3UEuy","arrow":"style_arrow__1NmmK"};